<template>
  <div>
    <!-- Hero -->
    <base-page-heading :title="$t('admin.items.title')">
      <template #extra>
        <b-breadcrumb class="breadcrumb-alt">
          <b-breadcrumb-item>
            <router-link to="/">{{ $t("layout.breadcrumb.home") }}</router-link>
          </b-breadcrumb-item>
          <b-breadcrumb-item>
            {{ $t("layout.breadcrumb.admin") }}
          </b-breadcrumb-item>
          <b-breadcrumb-item active>{{
            $t("admin.items.title")
          }}</b-breadcrumb-item>
        </b-breadcrumb>
      </template>
    </base-page-heading>
    <!-- END Hero -->

    <div class="content content-narrow">
      <b-row>
        <b-col xl="12">
          <base-block
            :title="$t('admin.items.search.title')"
            header-bg
            content-full
          >
            <b-form-group
              label-cols-sm="4"
              :label="$t('admin.items.search.competitor')"
              label-for="search-competitorId"
            >
              <select
                id="search-competitorId"
                v-model="search.competitorId"
                class="form-control"
              >
                <option value="0">{{
                  $t("admin.items.search.allCompetitors")
                }}</option>
                <option
                  v-for="competitor in competitors"
                  v-bind:key="competitor.competitorId"
                  v-bind:value="competitor.competitorId"
                >
                  {{ competitor.name }}
                </option>
              </select>
            </b-form-group>
            <b-form-group
              label-cols-sm="4"
              :label="$t('admin.items.search.itemName')"
              label-for="search-name"
            >
              <b-form-input
                id="search-name"
                type="text"
                :placeholder="$t('admin.items.search.allItemNames')"
                v-model="search.name"
                @keyup.enter="getItems"
              />
            </b-form-group>
            <b-form-group
              label-cols-sm="4"
              :label="$t('admin.items.search.itemDefinition')"
              label-for="search-itemDefinition"
            >
              <b-form-input
                id="search-itemDefinition"
                type="text"
                :placeholder="$t('admin.items.search.allItemDefinitions')"
                v-model="search.itemDefinition"
                @keyup.enter="getItems"
              />
            </b-form-group>
            <b-form-group
              label-cols-sm="4"
              :label="$t('admin.items.search.onlyFirstItem.title')"
              label-for="search-onlyFirstItem"
            >
              <select
                id="search-onlyFirstItem"
                v-model="search.onlyFirstItem"
                class="form-control"
              >
                <option value="both">{{
                  $t("admin.items.search.onlyFirstItem.both")
                }}</option>
                <option value="yes">{{
                  $t("admin.items.search.onlyFirstItem.yes")
                }}</option>
                <option value="no">{{
                  $t("admin.items.search.onlyFirstItem.no")
                }}</option>
              </select>
            </b-form-group>
            <div class="form-group form-row">
              <b-col xs="12" class="ml-auto text-right">
                <b-button type="submit" variant="primary" @click="getItems()">{{
                  $t("admin.items.search.button")
                }}</b-button>
              </b-col>
            </div>
          </base-block>
        </b-col>
      </b-row>
      <b-row v-if="items.length > 0">
        <b-col xl="12">
          <base-block
            :title="$t('admin.items.table.title')"
            header-bg
            content-full
          >
            <b-table-simple
              striped
              hover
              responsive
              borderless
              class="table-vcenter font-size-sm mb-0"
            >
              <b-thead>
                <b-tr>
                  <b-th class="font-w700 text-left">{{
                    $t("admin.items.table.competitor")
                  }}</b-th>
                  <b-th class="font-w700 text-left">{{
                    $t("admin.items.table.itemName")
                  }}</b-th>
                  <b-th class="font-w700 text-left">{{
                    $t("admin.items.table.itemDefinition")
                  }}</b-th>
                  <b-th class="font-w700 text-center">{{
                    $t("admin.items.table.onyFirstItem.title")
                  }}</b-th>
                  <b-th class="d-sm-table-cell font-w700">{{
                    $t("admin.items.table.action")
                  }}</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="item in items" :key="item.id">
                  <b-td class="text-left">
                    <router-link
                      :to="'/admin/items/' + item.id + '/'"
                      v-if="competitors[item.competitorId]"
                    >
                      {{ competitors[item.competitorId].name }}
                    </router-link>
                  </b-td>
                  <b-td class="text-left">
                    <router-link :to="'/admin/items/' + item.id + '/'">
                      {{ item.name }}
                    </router-link>
                  </b-td>
                  <b-td class="text-left">
                    <router-link
                      :to="'/admin/items/' + item.id + '/'"
                      class="font-w600"
                    >
                      {{ item.itemDefinition }}
                    </router-link>
                  </b-td>
                  <b-td class="text-center">
                    {{
                      $t("admin.items.table.onyFirstItem." + item.onlyFirstItem)
                    }}
                  </b-td>
                  <b-td class="d-sm-table-cell">
                    <router-link :to="'/admin/items/' + item.id + '/'">
                      <b-button size="sm" variant="alt-primary">
                        <i class="fa fa-fw fa-pencil-alt"></i>
                      </b-button>
                    </router-link>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </base-block>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Competitors from "@/assets/js/Competitors";
import Items from "@/assets/js/Items";
import Loading from "@/store/loading";

export default {
  name: "Items",
  components: {},
  data() {
    return {
      competitors: [],
      items: [],
      search: {
        competitorId: 0,
        name: "",
        itemDefinition: "",
        onlyFirstItem: "both"
      }
    };
  },
  mounted() {
    document.title = this.$t("admin.items.title");

    Loading.dispatch("increase");

    Competitors.get().then(competitors => {
      let competitorList = {};

      for (let i in competitors) {
        if (Object.prototype.hasOwnProperty.call(competitors, i)) {
          competitorList[competitors[i].competitorId] = competitors[i];
        }
      }

      this.$set(this, "competitors", competitorList);
      Loading.dispatch("reduce");
    });
  },
  updated() {},
  methods: {
    getItems: function() {
      Loading.dispatch("increase");
      Items.get(
        this.search.competitorId,
        this.search.name,
        this.search.itemDefinition,
        this.search.onlyFirstItem
      ).then(itemList => {
        this.$set(this, "items", itemList);
        Loading.dispatch("reduce");
      });
    }
  },
  computed: {}
};
</script>
